const mutations = {
  backupReport(state, backupReport) {
    state.backupReport = backupReport
  },
  isCreatingReport(state, isCreatingReport) {
    state.isCreatingReport = isCreatingReport
  },
  isSubmittingReportUpdate(state, isSubmittingReportUpdate) {
    state.isSubmittingReportUpdate = isSubmittingReportUpdate
  },
  modalData(state, modalData) {
    state.modalData = modalData
  },
  reports(state, reports) {
    state.reports = reports
  },
  selectedReport(state, selectedReport) {
    state.selectedReport = selectedReport
  },
  showArchivedReports(state, showArchivedReports) {
    state.showArchivedReports = showArchivedReports
  },
  showModalArchiveReport(state, showModalArchiveReport) {
    state.showModalArchiveReport = showModalArchiveReport
  },
  showModalDisplayAsFavorite(state, showModalDisplayAsFavorite) {
    state.showModalDisplayAsFavorite = showModalDisplayAsFavorite
  },
  showModalDisplayAsMetric(state, showModalDisplayAsMetric) {
    state.showModalDisplayAsMetric = showModalDisplayAsMetric
  },
  showModalEnforceCriteria(state, showModalEnforceCriteria) {
    state.showModalEnforceCriteria = showModalEnforceCriteria
  },
  showModalReportInfo(state, showModalReportInfo) {
    state.showModalReportInfo = showModalReportInfo
  },
  showModalShare(state, showModalShare) {
    state.showModalShare = showModalShare
  },
  showModalUserInputValue(state, showModalUserInputValue) {
    state.showModalUserInputValue = showModalUserInputValue
  },
  showShareFormInputs(state, showShareFormInputs) {
    state.showShareFormInputs = showShareFormInputs
  },
}

export default mutations
